import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Condition } from './condition.model';

@Injectable({
  providedIn: 'root'
})
export class ConditionService {

  constructor(private readonly http: HttpClient) {
  }

  getCondition(q: string) {
    const params = {
      q
    };

    return this.http.get<Condition[]>('condition/', { params });
  }

}
